import Splide from '@splidejs/splide';

const EL = '.js-show-instagram'
const ELS = document.querySelectorAll(EL);

ELS.forEach((EL) => {
  new Splide( EL, {
    perMove: 1,
    pagination: false,
    gap: '40px',
    fixedWidth: '363px',
    breakpoints: {
      '768': {
        fixedWidth: '240px',
        gap: '20px',
      },
    },
  } ).mount();
});
